export function itemsFrom(response) {
  return response?.data?.results || response?.data || []
}

export function plainTextFromHtml(html = '') {
  return String(html)
    .replace(/<script[\s\S]*?<\/script>/gi, ' ')
    .replace(/<style[\s\S]*?<\/style>/gi, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/\s+/g, ' ')
    .trim()
}

export function excerptFromHtml(html, length = 180) {
  const text = plainTextFromHtml(html)
  return text.length > length ? `${text.slice(0, length).trim()}...` : text
}

export function estimateReadingMinutes(html) {
  const text = plainTextFromHtml(html)
  if (!text) return 1
  const cjkCharacters = (text.match(/[\u3400-\u9fff]/g) || []).length
  const words = text.split(/\s+/).filter(Boolean).length
  return Math.max(1, Math.ceil(cjkCharacters / 450 + words / 220))
}

export function formatLocalizedDate(dateString, language = 'en') {
  if (!dateString) return ''
  const date = new Date(dateString)
  if (Number.isNaN(date.getTime())) return ''
  const locales = {en: 'en-US', zh: 'zh-CN', es: 'es-ES', ar: 'ar', fr: 'fr-FR'}
  return new Intl.DateTimeFormat(locales[language] || locales.en, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }).format(date)
}

export function applyImageFallback(event, fallback = '/images/engineering/slider_1.jpg') {
  if (event.target.dataset.fallbackApplied) return
  event.target.dataset.fallbackApplied = 'true'
  event.target.src = fallback
}
